import React from 'react';
import './App.css';
import ProjectTable from "./components/ProjectTable";
import ProjectNavbar from "./components/ProjectNavbar";



class TrueNorthSAHome extends React.Component {
    constructor(props) {
        super(props);

        let u = this.getUrlVars();

        this.state = {
            name: '',
            url: u,       
          }; 

    }

componentDidMount() {
    this.getUrlVars();
}

getUrlVars =() => {
    let vars = {};
    let parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    let x = "https://www.dropbox.com" + vars.x;
    return x;
}

render() {

    const {url} = this.state;

    return (

        <div>
           <ProjectNavbar parent={this}></ProjectNavbar> 
           <ProjectTable ref={node=>{this.tableref = node;}} app={this} url={url}></ProjectTable>      
        </div>

        );
    }
}
    
export default TrueNorthSAHome;